import { ref } from "vue";

const isDark = ref(false);

function applyTheme(dark) {
  document.documentElement.classList.toggle("dark", dark);
}

function savedTheme() {
  try {
    return localStorage.getItem("theme");
  } catch (e) {
    return null;
  }
}

export function useColorTheme() {
  function toggle() {
    isDark.value = !isDark.value;
    try {
      localStorage.setItem("theme", isDark.value ? "dark" : "light");
    } catch (e) {
      /* 保存できなくても表示の切り替えは行う */
    }
    applyTheme(isDark.value);
  }

  function init() {
    // FOUC防止のため実際のテーマ決定は public/index.html のインラインスクリプトが
    // 描画前に行っている（保存された選択 > OSの配色設定）。ここではその結果に
    // 状態を同期させるだけにして、判定ロジックの二重管理を避ける
    isDark.value = document.documentElement.classList.contains("dark");
    applyTheme(isDark.value);

    // ユーザーが明示的に選択するまでは、OSの配色設定の変更に追従する
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    mq.addEventListener("change", (e) => {
      if (savedTheme()) return;
      isDark.value = e.matches;
      applyTheme(e.matches);
    });
  }

  return { isDark, toggle, init };
}
